import React from 'react'
import './header.css'

const Header = () => {
    return (
        <header>
            <div className="container header__container">
                <h1>Stay Ahead of the Curve</h1>
            </div>
        </header>
    )
}

export default Header